export default __webpack_public_path__ + "static/media/AloeVera.68ebabf7.png";